import { store } from ".."
import { setError } from '../redux/actions/errors/index';

export const setErrorToState = (err: any) => {
    store.dispatch(setError(err));
}